$(document).on("click", ".currencySelector__header", function() {
  $(this).closest(".currencySelector").toggleClass("open");
  $(this).closest(".currencySelector").find(".currencySelector__content").fadeToggle();
});

$(document).on("click", ".currencySelector__item", function() {
  const $currencySelectorWrapper = $(this).closest(".currencySelector");
  const selectedValue = $(this).attr("data-value");
  $currencySelectorWrapper.find(".currencySelector__input").val(selectedValue);
  $currencySelectorWrapper.find(".currencySelector__headerItem").empty().append($(this).children().clone());
  $currencySelectorWrapper.removeClass("open");
  $(this).closest(".currencySelector__content").fadeOut();
  // Submit the localization form with the updated country_code
  const $form = $currencySelectorWrapper.find('form');
  if ($form.length) {
    $form.trigger('submit');
  }
});

$(window).on("click", function(event) {
  if(!$(event.target).closest(".currencySelector").length) {
	$(".currencySelector").removeClass("open");
	$(".currencySelector__content").fadeOut();
  }
});
